const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kava',
            client_id: '07-tendermint-163',
            connection_id: 'connection-204'
        },
        chain_2: {
            chain_name: 'onex',
            client_id: '07-tendermint-1',
            connection_id: 'connection-13'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-145',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-4',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'noble',
            client_id: '07-tendermint-98',
            connection_id: 'connection-91'
        },
        chain_2: {
            chain_name: 'onex',
            client_id: '07-tendermint-6',
            connection_id: 'connection-14'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-78',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-5',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'onex',
            client_id: '07-tendermint-7',
            connection_id: 'connection-15'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3202',
            connection_id: 'connection-2659'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-6',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-74628',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
